<template>
  <div>
    <slot />

    <modal-manager />

    <Toast position="bottom-right" group="br" />
  </div>
</template>
